APP_CONTAINER_VERSION = '12.33.23';
APP_CORE_VERSION = '12.43.12';
APP_CONTAINER_NAME = 'self-digital-fe';
APP_CORE_NAME = 'self-digital-core-fe';
